import { render, staticRenderFns } from "./Mepandes.vue?vue&type=template&id=ec05dd84&scoped=true&"
import script from "./Mepandes.vue?vue&type=script&lang=js&"
export * from "./Mepandes.vue?vue&type=script&lang=js&"
import style0 from "./Mepandes.vue?vue&type=style&index=0&id=ec05dd84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec05dd84",
  null
  
)

export default component.exports